<template>
  <div>
    <el-card>
      <div class="mainLogoPosition">
      <img src="@/assets/echob2b_logo.svg" class="mb-5 ">
    </div>
    <el-row>
      <el-col>
        <el-form v-if="loginCard" :model="LoginForm" status-icon :rules="rules" ref="LoginForm" label-width="120px" class="LForm">
          <el-form-item prop="username">
            <el-input v-model="LoginForm.username" placeholder="Username">
              <span slot="prepend">
                     <svg xmlns="http://www.w3.org/2000/svg" width="19" height="12" viewBox="0 0 19 12">
                          <path fill="#5C5C5C" fill-rule="nonzero" d="M1.282 2.848v7.448c0 .342.278.62.62.62h15.12a.62.62 0 0 0 .62-.62V2.783l-7.246 4.419c-.607.37-1.368.37-1.975 0L1.28 2.848zm0-.929l7.552 4.606c.353.215.796.215 1.15 0l7.657-4.67a.621.621 0 0 0-.62-.607H1.902a.621.621 0 0 0-.62.622v.05zm15.74 9.79H1.901c-.78 0-1.413-.633-1.413-1.413V1.87c0-.781.633-1.415 1.413-1.415h15.12c.78 0 1.413.634 1.413 1.415v8.426c0 .78-.633 1.413-1.414 1.413z"/>
                      </svg>
                  </span>
            </el-input>
          </el-form-item>
          <el-form-item prop="pass">
            <el-input type="password" v-model="LoginForm.pass" @keyup.enter.native="submitForm('LoginForm')" auto-complete="off" placeholder="Password">
              <span slot="prepend">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16">
                        <path fill="#5C5C5C" fill-rule="nonzero" d="M11.074 14.653a.71.71 0 0 0 .71-.71V6.704a.711.711 0 0 0-.71-.712H2.156a.712.712 0 0 0-.71.712v7.237c0 .393.318.711.71.711h8.918zm-8.086-9.39V3.68a3.627 3.627 0 1 1 7.254 0v1.583h.832c.795 0 1.44.646 1.44 1.442v7.237a1.44 1.44 0 0 1-1.44 1.441H2.156a1.441 1.441 0 0 1-1.441-1.44V6.704c0-.796.645-1.442 1.441-1.442h.832zm.73 0h5.793V3.68a2.896 2.896 0 1 0-5.793 0v1.583zm3.922 5.06a1.024 1.024 0 1 1-2.05 0 1.024 1.024 0 0 1 2.05 0zm.73 0a1.755 1.755 0 1 0-3.51 0 1.755 1.755 0 0 0 3.51 0z"/>
                    </svg>
                  </span>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('LoginForm')">Login</el-button>
          </el-form-item>
          <p class="text-center pointer resetText" @click="resetPass">Forgot password?</p>
        </el-form>
        <el-form v-else :model="ResetForm" status-icon :rules="ResetRules" ref="ResetForm" label-width="120px" class="LForm">
          <el-form-item prop="Email">
            <el-input v-model="ResetForm.Email" @keyup.enter.native="submitResetForm('ResetForm')" auto-complete="off" placeholder="Email">
              <span slot="prepend">
                     <svg xmlns="http://www.w3.org/2000/svg" width="19" height="12" viewBox="0 0 19 12">
                          <path fill="#5C5C5C" fill-rule="nonzero" d="M1.282 2.848v7.448c0 .342.278.62.62.62h15.12a.62.62 0 0 0 .62-.62V2.783l-7.246 4.419c-.607.37-1.368.37-1.975 0L1.28 2.848zm0-.929l7.552 4.606c.353.215.796.215 1.15 0l7.657-4.67a.621.621 0 0 0-.62-.607H1.902a.621.621 0 0 0-.62.622v.05zm15.74 9.79H1.901c-.78 0-1.413-.633-1.413-1.413V1.87c0-.781.633-1.415 1.413-1.415h15.12c.78 0 1.413.634 1.413 1.415v8.426c0 .78-.633 1.413-1.414 1.413z"/>
                      </svg>
                  </span>
            </el-input>
          </el-form-item>
           <p class="text-center">Enter your email and we will send you an email to change the password!</p>
          <el-form-item>
            <el-button type="primary" @click="submitResetForm('ResetForm')">Submit</el-button>
          </el-form-item>
          <p class="text-center pointer resetText" @click="resetPass">Back to login</p>
        </el-form>
        <!-- <form class="login" @submit.prevent="login">
              <h1>Sign in</h1>
              <label>User name</label>
              <input required v-model="username" type="text" placeholder="Snoopy"/>
              <label>Password</label>
              <input required v-model="password" type="password" placeholder="Password"/>
              <hr/>
              <button type="submit">Login</button>
              </form> -->
      </el-col>
    </el-row>
    </el-card>
  </div>
</template>

<script>
import {AUTH_REQUEST} from '@/store/actions/auth'
import {validateEmail} from '@/utils/validate'
import {ResetPassApi} from '@/utils/echoApi'
import { mapState } from 'vuex'
export default {
  data () {
    // var validatePass = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error('Please input the password'))
    //   } else {
    //     if (this.ruleForm.checkPass !== '') {
    //       // this.$refs.ruleForm.validateField('checkPass')
    //       alert('έλεγχος regex κωδικού')
    //     }
    //     callback()
    //   }
    // }
    const validateUsername = (rule, value, callback) => {
      if (!validateEmail(value)) {
        callback(new Error('Please enter a valid email'))
      } else {
        callback()
      }
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('The password cannot be empty'))
      } else if (value.length < 2) {
        callback(new Error('The password can not be less than 6 digits'))
      } else {
        callback()
      }
    }
    return {
      // username: 'dogo',
      // password: 'dogy',
      loginCard: true,
      LoginForm: {
        username: '',
        pass: ''
      },
      rules: {
        username: [{required: true, trigger: 'blur'}],
        pass: [{required: true, trigger: 'blur', validator: validatePassword}]
      },
      ResetRules: {
        Email: [{required: true, trigger: 'blur', validator: validateUsername}]
      },
      ResetForm: {
        Email: ''
      }
    }
  },
  computed: {
    ...mapState('data', {
      hostname: state => state.hostname
    })
  },
  methods: {
    resetPass () {
      this.loginCard = !this.loginCard
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { username, pass } = this.LoginForm
          this.$store.dispatch(AUTH_REQUEST, { username, pass }).then(() => {
            this.$router.push('/dashboard')
          }).catch((error) => {
            this.loading = false
            if (error.response.status === 422) {
              this.open()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    submitResetForm (formName) {
      var self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('https://' + this.hostname + ResetPassApi, {
            email: this.ResetForm.Email
          })
            .then((response) => {
              if (response.status === 200) {
                // this.AddTaskForm.assignee = this.AddTaskForm.assigned_id[0]
                // this.$store.commit('data/addNewTask', this.AddTaskForm)
                this.$message({
                  message: 'reset password done',
                  type: 'success'
                })
                setTimeout(function () { self.loginCard = !this.loginCard }, 2000)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        }
      })
    },
    open () {
      this.$notify.error({
        title: 'Error',
        message: 'Wrong Credentials'
      })
    }
  }
}
</script>
<style  lang="scss">
.LForm
{
  .el-input-group__prepend {
    background-color: #edf0f0;
    border: none;
    padding-right: 0px;
}
.el-form-item__content
{
  margin-left: 0px !important;
}
.el-input__inner
{
  background-color: #edf0f0;
  border: none;
}
.el-button--primary {
    border-radius: 2px;
    background-color: #03a7fa;
    width: 100%;
}
.card
{
  width: 464px;
  height: 329.8px;
}
}
.mainLogoPosition {
  position: relative;
  left: 105px;
  width: 50%;
}
.resetText {
  color: var(--main-color);
  font-size: 12px;
}
@media (max-width:530px) {
 .mainLogoPosition {
  left: 50px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/LoginForm/index.vue